import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PatientsState } from "../interfaces/Patients";
import apiClient from "../api/apiClient";

interface ProfileState {
  loading: boolean;
  user: PatientsState | null;
  error: string | null;
  isLoggedIn: boolean;
  data: PatientsState[] | null;
}

const initialState: ProfileState = {
  loading: false,
  user: null,
  error: null,
  isLoggedIn: false,
  data: null,
};

export const ProfileDetails = createAsyncThunk(
  "profile/ProfileDetails",
  async (_, thunkAPI) => {
    try {
      const response = await apiClient.get("/api/v1/patients/profile");
      return response.data.data.user;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(`Fetch failed: ${error.message}`);
    }
  },
);

export const UpdateProfile = createAsyncThunk(
  "profile/UpdateProfile",
  async (updatedProfileData: any, thunkAPI) => {
    try {
      const response = await apiClient.put(
        "/api/v1/patients/profile",
        updatedProfileData,
      );
      return response.data.data.user;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(`Update failed: ${error.message}`);
    }
  },
);

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ProfileDetails.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(ProfileDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // Check the correct path
      })
      .addCase(ProfileDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error creating payment intent:", action.payload); // Log the detailed error
      })
      .addCase(UpdateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(UpdateProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(UpdateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        console.error("Error updating profile:", action.payload);
      });
  },
});

export const { resetState } = profileSlice.actions;
export default profileSlice.reducer;
